/**
 * @file element ui plugin
 * @author  fangsimin
 * @date    2019-01-02 13:29:03
 * @last Modified by    fangsimin
 * @last Modified time  2019-01-02 13:29:17
 */

import Vue from 'vue';
import Element from 'element-ui';
import '../element-variables.scss';

// 临时解决element data-picker报错问题，具体https://github.com/ElemeFE/element/issues/21905
function RepairProps(cmp) {
    (cmp.mixins || []).forEach(mixin => {
        if (mixin.props && mixin.props.placement) {
            const defaultValue = mixin.props.placement.default;
            mixin.data = new Proxy(mixin.data, {
                apply(target, thisArg, argArray) {
                    const res = Reflect.apply(target, thisArg, argArray);
                    return {
                        ...(res || {}),
                        placement: defaultValue
                    };
                }
            });
            delete mixin.props.placement;
        }
        if (mixin.mixins && mixin.mixins.length > 0) {
            RepairProps(mixin);
        }
    });
}

RepairProps(Element.DatePicker);
RepairProps(Element.TimePicker);
RepairProps(Element.TimeSelect);

Vue.use(Element);



// WEBPACK FOOTER //
// ./src/plugins/element.js